import { formatLocalElectionOfficeLink } from '~utils/faqAnswerUtils';

const externalResources = [
  { field: 'gov_tool_registration', label: 'online voter registration' },
  {
    field: 'gov_tool_absentee_request',
    label: 'online absentee ballot request',
  },
  { field: 'gov_tool_verify', label: 'voter status lookup' },
  {
    field: 'gov_tool_absentee_tracker',
    label: 'absentee ballot tracker',
  },
  {
    field: 'gov_tool_provisional_tracker',
    label: 'provisional ballot tracker',
  },
  { field: 'gov_tool_polling_place', label: 'polling place locator' },
];

const references = [
  {
    field: 'source_early_voting_info',
    label: 'early voting information',
  },
  { field: 'source_absentee_info', label: 'absentee ballot information' },
  {
    field: 'source_registration_info',
    label: 'voter registration information',
  },
  { field: 'source_voter_id_info', label: 'voter ID information' },
  {
    field: 'source_student_voting_info',
    label: 'student voter information',
  },
  {
    field: 'source_rights_restoration_info',
    label: 'voting rights restoration for voters with felony convictions',
  },
  { field: 'source_election_code', label: 'election code' },
];

export const whatIfIHaveOtherQuestions = (stateCode) => {
  const paragraphs = [];
  paragraphs.push(
    `Contact your ${formatLocalElectionOfficeLink(
      stateCode
    )} if you have any questions about participating in this election.`
  );
  paragraphs.push(`If anyone tries to stop you from voting, call or text the [National Election Protection Hotline](https://866ourvote.org/). 
  Their number is 866-OUR-VOTE (866-687-8683).`);

  return paragraphs.join('\n\n');
};

export const howDoIContactMyLocalElectionOffice = (stateCode) => {
  return `Use [this tool](/local-election-offices/${stateCode}) to look up contact information for your local election office.`;
};

export const whoIsInChargeOfMyElections = (stateInfo, stateName, stateCode) => {
  const paragraphs = [];
  paragraphs.push(
    `The statewide agency that is ultimately responsible for ${stateName} elections is listed below. 
    You can contact them with questions, but your ${formatLocalElectionOfficeLink(stateCode)} will probably respond faster.`
  );

  const preformattedItems = [];
  preformattedItems.push(stateInfo.nvra_submission_address.text);
  if (stateInfo.sos_phone_number.text) {
    preformattedItems.push(`Phone: ${stateInfo.sos_phone_number.text}`);
  }
  if (stateInfo.sos_contact_email.text) {
    preformattedItems.push(`Email: ${stateInfo.sos_contact_email.text}`);
  }
  paragraphs.push(`\`\`\`${preformattedItems.join('\n\n')}`);

  return paragraphs.join('\n\n');
};

export const whereCanIFindVotingResources = (stateInfo, stateName) => {
  const paragraphs = [];
  paragraphs.push(`${stateName} operates the following voter tools:`);

  const items = [];
  for (let i = 0; i < externalResources.length; i += 1) {
    const link = externalResources[i];
    if (stateInfo[link.field].text) {
      items.push(
        `* [${stateName} ${link.label}](${stateInfo[link.field].text})`
      );
    }
  }
  paragraphs.push(items.join('\n'));

  return paragraphs.join('\n\n');
};

export const whatAreTheSourcesForThisInformation = (stateInfo, stateName) => {
  const paragraphs = [];
  paragraphs.push(`Information on this page comes from ${stateName} state statutes 
  or guidance from ${stateName} election authorities. The following links have more information:`);

  const items = [];
  for (let i = 0; i < externalResources.length; i += 1) {
    const link = references[i];
    if (stateInfo[link.field].text) {
      items.push(
        `* [${stateName} ${link.label}](${stateInfo[link.field].text})`
      );
    }
  }
  paragraphs.push(items.join('\n'));

  return paragraphs.join('\n\n');
};
